export const decodeJWT = (jwtToken: string) => {
    try {
        const arr = jwtToken.split('.');
        if (arr.length !== 3) {
            throw new Error('Invalid JWT format: expected 3 parts separated by dots.');
        }

        const payload = arr[1];
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');

        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join(''),
        );
        const payloadData = JSON.parse(jsonPayload);
        return payloadData?.wallet;
    } catch (error) {
        console.error('Error decoding JWT:', error);
        throw new Error('Failed to decode JWT');
    }
};
